import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { blockLabel, childSlots, outlineRows, slotLabel } from './blockPresentation';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';

export const destinationKey = (destination) => destination ? JSON.stringify([destination.parentId, destination.slotKey]) : '';
export const readDestination = (value) => {
  const [parentId, slotKey] = JSON.parse(value);
  return { parentId, slotKey };
};

const BlockDestination = ({ canvas, value, onChange, exclude = [], disabled = false }) => {
  const t = useLocalizedMessage();
  const pathLabel = (row, slot) => {
    if (row.node.type === 'columns') {
      const firstContent = (id, seen = new Set()) => {
        if (seen.has(id)) return null;
        seen.add(id);
        const node = canvas.nodes.find(item => item.id === id);
        if (node?.type !== 'columns') return node;
        return childSlots(node).flatMap(([, ids]) => ids).map(child => firstContent(child, seen)).find(Boolean);
      };
      const anchor = row.node.slots[slot].map(id => firstContent(id)).find(Boolean);
      return anchor ? t('experience.design.withBlock', { name: blockLabel(anchor, t) })
        : t('experience.design.emptyArea');
    }
    return [blockLabel(row.node, t, canvas.root), slotLabel(slot, t)].join(' / ');
  };
  const destinations = outlineRows(canvas, t, true).filter(row => !exclude.includes(row.node.id)).flatMap(row => (
    childSlots(row.node).map(([slot]) => ({
      value: destinationKey({ parentId: row.node.id, slotKey: slot }),
      label: pathLabel(row, slot),
    }))
  ));
  const selected = destinationKey(value);
  return <TextField
    select fullWidth variant="outlined" size="small" label={t('experience.design.addLocation')}
    value={destinations.some(option => option.value === selected) ? selected : ''}
    onChange={event => onChange(readDestination(event.target.value))} disabled={disabled}
    SelectProps={{ inputProps: { 'aria-label': t('experience.design.addLocation') } }}
  >{destinations.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}</TextField>;
};

export default BlockDestination;
